/* THIS IS A GENERATED FILE, DO NOT EDIT MANUALLY! */
/* eslint-disable -- This is a generated file */

// import hooks
import useSwr from "../useGet.hook";

// import types
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import type { SWRConfig } from "../useGet.hook";

/**
 * SWR hook useGetStyleHook
 */
export const useGetStyleHook = (axiosConfig?: AxiosRequestConfig, swrConfig?: SWRConfig<AxiosResponse<undefined>>) =>
  useSwr<undefined>(
    {
      url: `/style`,
      method: "get",
      params: {},
      ...axiosConfig,
    },
    swrConfig,
  );

export default useGetStyleHook;
